import { render } from "./PanelMenu.vue?vue&type=template&id=3272e7c4"
import script from "./PanelMenu.vue?vue&type=script&lang=js"
export * from "./PanelMenu.vue?vue&type=script&lang=js"

import "./PanelMenu.vue?vue&type=style&index=0&id=3272e7c4&lang=css"
script.render = render

export default script